import { Question } from './question';

export type AttributeMeta = {
  id?: number;
  entity_type?: string;
  attribute_type?: string;
  attribute_name?: string;
  label?: string;
  questions?: Question[];
  archived?: boolean;
  formula?: string | null;
  slug?: string;
  enableFormula?: boolean;
  slug_entity_type?: string;
  slug_attribute_meta_id?: number;
};

export type CalculatedAttributeMeta = {
  id?: string;
  user_id?: number;
  attribute_name?: string;
  value?: string;
};

export class AttributeMetaClass implements AttributeMeta {
  id = 0;
  entity_type = '';
  attribute_type = '';
  attribute_name = '';
  label = '';
  questions = [];
  archived = false;
  formula = '';
  enableFormula = false;
  slug_entity_type = '';
  slug_attribute_meta_id = 0;
}

export interface GetAttributesMetaByEntityType {
  entity_type: string;
  status_archived?: boolean;
  not_set?: boolean;
}

export const ATTRIBUTE_META_TYPES = [
  'number',
  'string',
  'bool',
  'date',
] as const;

export type AttributeMetaType = (typeof ATTRIBUTE_META_TYPES)[number];
